// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1ksGL","messages":"Chat_messages__2Acmo","dateDivider":"Chat_dateDivider__D2_XV"};